import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "fixed z-50",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = {
  id: "dialog",
  class: "bounce-modal-animation flex min-h-full items-center justify-center p-0 px-4 text-center"
}
const _hoisted_3 = { class: "absolute top-[-80px] right-0 left-0 z-20 flex flex-col items-center justify-center rounded-full" }
const _hoisted_4 = ["color"]
const _hoisted_5 = {
  key: 0,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  color: "#FF5252",
  "fill-rule": "nonzero",
  d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
}
const _hoisted_6 = ["color"]
const _hoisted_7 = { class: "mt-10 flex flex-col items-center text-grey" }
const _hoisted_8 = { class: "flex justify-center space-x-2" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_10 = {
  key: 1,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_11 = {
  key: 2,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_12 = {
  key: 0,
  class: "flex items-center justify-center text-xs"
}
const _hoisted_13 = {
  key: 1,
  class: "font-semibold mt-3"
}
const _hoisted_14 = {
  key: 2,
  class: "text-start"
}
const _hoisted_15 = {
  key: 0,
  class: "text-center"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "font-semibold mb-3 text-center"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = {
  key: 3,
  class: "font-semibold mt-3"
}
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = {
  key: 5,
  class: "m-auto"
}
const _hoisted_26 = ["color"]
const _hoisted_27 = {
  key: 6,
  class: "m-auto"
}
const _hoisted_28 = ["color"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_component = _resolveComponent("button-component")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    duration: 600
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "fixed top-0 right-0 left-0 bottom-0 bg-gray-400 bg-opacity-75 transition-opacity" }, null, -1)),
        _createElementVNode("div", {
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onClickOutside && _ctx.onClickOutside(...args))),
          class: "fixed top-0 right-0 left-0 bottom-0 z-10 overflow-y-hidden"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
              class: "relative h-min w-full rounded-lg bg-background p-8 shadow-xl"
            }, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createElementBlock("svg", {
                  fill: "white",
                  class: "h-[150px] w-[150px]",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  color: _ctx.validateColor('icon'),
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  (_ctx.type === 'error')
                    ? (_openBlock(), _createElementBlock("path", _hoisted_5))
                    : _createCommentVNode("", true),
                  (_ctx.type === 'success' || _ctx.type === 'warning')
                    ? (_openBlock(), _createElementBlock("path", {
                        key: 1,
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1.5",
                        "fill-rule": "nonzero",
                        color: _ctx.validateColor('icon'),
                        d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_4))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.appName && _ctx.isBrand.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.appName), 1))
                    : _createCommentVNode("", true),
                  (_ctx.platformApp)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.platformApp), 1))
                    : _createCommentVNode("", true),
                  (_ctx.appVersion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.appVersion), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.userData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.userData.phone_number), 1))
                  : _createCommentVNode("", true),
                (_ctx.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.description), 1))
                  : _createCommentVNode("", true),
                (_ctx.block_balance)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_ctx.block_balance.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createTextVNode(_toDisplayString(_ctx.block_balance.error), 1),
                            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                            _cache[15] || (_cache[15] = _createTextVNode("Обратитесь к партнеру. ", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "font-semibold text-center" }, " Заблокированные балансы ", -1)),
                            (this.block_balance?.block_balance)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Общий: " + _toDisplayString(this.block_balance?.block_balance), 1))
                              : _createCommentVNode("", true),
                            (this.block_balance?.blocked_cashless)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " За поездки: " + _toDisplayString(this.block_balance.blocked_cashless), 1))
                              : _createCommentVNode("", true),
                            (this.block_balance?.blocked_tips)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, " За чаевые: " + _toDisplayString(this.block_balance.blocked_tips), 1))
                              : _createCommentVNode("", true),
                            (this.block_balance?.blocked_bonuses)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, " За бонусы: " + _toDisplayString(this.block_balance.blocked_bonuses), 1))
                              : _createCommentVNode("", true),
                            (this.block_balance?.blocked_financial_statements)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, " За финансовые отчеты: " + _toDisplayString(this.block_balance.blocked_financial_statements), 1))
                              : _createCommentVNode("", true),
                            (this.block_balance?.blocked_closing_documents)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, " За закрывающие документы: " + _toDisplayString(this.block_balance.blocked_closing_documents), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.htmlDescription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("p", { innerHTML: _ctx.htmlDescription }, null, 8, _hoisted_24)
                    ]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "description"),
                (_ctx.isWithdrawalConditions)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: "my-2 text-xs text-gray-400 text-center cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('withdrawalConditions')))
                    }, [...(_cache[17] || (_cache[17] = [
                      _createTextVNode(" Проверьте условия ", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" вывода «Парка» ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (
                  (_ctx.isPaymentsOff === false &&
                    _ctx.cards?.length &&
                    _ctx.cardIsActivate) ||
                  _ctx.isActiveCard === 'Подтвердить карту' ||
                  _ctx.isActiveCard === 'support'
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_ctx.hasMaxSupport)
                        ? (_openBlock(), _createBlock(_component_button_component, {
                            key: 0,
                            onOpenMax: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openMax'))),
                            "full-width": false,
                            height: "10",
                            class: "mt-5",
                            "input-class": "px-12",
                            rounded: "lg",
                            title: "Написать в MAX",
                            "text-color": "white",
                            icon: "max",
                            color: _ctx.validateColor('button')
                          }, null, 8, ["color"]))
                        : _createCommentVNode("", true),
                      (_ctx.hasTmSupport)
                        ? (_openBlock(), _createBlock(_component_button_component, {
                            key: 1,
                            onOpenTelegram: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openTelegram'))),
                            "full-width": false,
                            height: "10",
                            class: "mt-5",
                            "input-class": "px-12",
                            rounded: "lg",
                            title: "Написать в Telegram",
                            "text-color": "white",
                            icon: "tg",
                            color: _ctx.validateColor('button')
                          }, null, 8, ["color"]))
                        : _createCommentVNode("", true),
                      (_ctx.hasWaSupport)
                        ? (_openBlock(), _createBlock(_component_button_component, {
                            key: 2,
                            onClickAction: _cache[3] || (_cache[3] = ($event: any) => (
                    _ctx.$emit(
                      _ctx.isActiveCard === 'Подтвердить карту'
                        ? 'confirmCard'
                        : 'decline',
                    )
                  )),
                            "full-width": false,
                            height: "10",
                            class: "mt-5",
                            "input-class": "px-12",
                            rounded: "lg",
                            title: "Написать в WhatsApp",
                            "text-color": "white",
                            icon: "wa",
                            color: _ctx.validateColor('button')
                          }, null, 8, ["color"]))
                        : _createCommentVNode("", true),
                      (_ctx.hasEmailSupport)
                        ? (_openBlock(), _createBlock(_component_button_component, {
                            key: 3,
                            onOpenEmail: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('openEmail'))),
                            "full-width": false,
                            height: "10",
                            class: "mt-5",
                            "input-class": "px-12",
                            rounded: "lg",
                            title: "Написать на почту",
                            "text-color": "white",
                            icon: "email",
                            color: _ctx.validateColor('button')
                          }, null, 8, ["color"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('confirm'))),
                        height: "10",
                        class: "mt-5 font-semibold",
                        color: _ctx.validateColor('button')
                      }, " Отмена ", 8, _hoisted_26)
                    ]))
                  : (_ctx.isSupportModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (_ctx.hasMaxSupport)
                          ? (_openBlock(), _createBlock(_component_button_component, {
                              key: 0,
                              onOpenMax: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('max'))),
                              "full-width": false,
                              height: "10",
                              class: "mt-5",
                              "input-class": "px-12",
                              rounded: "lg",
                              title: "Написать в MAX",
                              "text-color": "black",
                              icon: "max",
                              color: _ctx.validateColor('button')
                            }, null, 8, ["color"]))
                          : _createCommentVNode("", true),
                        (_ctx.hasTmSupport)
                          ? (_openBlock(), _createBlock(_component_button_component, {
                              key: 1,
                              onOpenTelegram: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('tm'))),
                              "full-width": false,
                              height: "10",
                              class: "mt-5",
                              "input-class": "px-12",
                              rounded: "lg",
                              title: "Написать в Telegram",
                              "text-color": "black",
                              icon: "tg",
                              color: _ctx.validateColor('button')
                            }, null, 8, ["color"]))
                          : _createCommentVNode("", true),
                        (_ctx.hasWaSupport)
                          ? (_openBlock(), _createBlock(_component_button_component, {
                              key: 2,
                              onClickAction: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('wa'))),
                              "full-width": false,
                              height: "10",
                              class: "mt-5",
                              "input-class": "px-12",
                              rounded: "lg",
                              title: "Написать в WhatsApp",
                              "text-color": "black",
                              icon: "wa",
                              color: _ctx.validateColor('button')
                            }, null, 8, ["color"]))
                          : _createCommentVNode("", true),
                        (_ctx.hasEmailSupport)
                          ? (_openBlock(), _createBlock(_component_button_component, {
                              key: 3,
                              onOpenEmail: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('openEmail'))),
                              "full-width": false,
                              height: "10",
                              class: "mt-5",
                              "input-class": "px-12",
                              rounded: "lg",
                              title: "Написать на почту",
                              "text-color": "black",
                              icon: "email",
                              color: _ctx.validateColor('button')
                            }, null, 8, ["color"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('confirm'))),
                          height: "10",
                          class: "mt-5 font-semibold",
                          color: _ctx.validateColor('button')
                        }, " Отмена ", 8, _hoisted_28)
                      ]))
                    : (_openBlock(), _createBlock(_component_button_component, {
                        key: 7,
                        onClickAction: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('confirm'))),
                        "full-width": false,
                        height: "10",
                        class: "mt-5",
                        "input-class": "px-12",
                        rounded: "lg",
                        title: _ctx.buttonText,
                        "text-color": "white",
                        color: _ctx.validateColor('button')
                      }, null, 8, ["title", "color"]))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["absolute bottom-[-10px] left-0 right-0 z-[-1] ml-auto mr-auto h-12 w-11/12 rounded-lg", {
                'bg-red': _ctx.type === 'error',
                'bg-green': _ctx.type === 'success',
                'bg-primary': _ctx.type === 'warning',
              }])
              }, null, 2)
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state]
      ])
    ]),
    _: 3
  }))
}